import React                   from 'react';
import { connect }             from 'react-redux';
import EggBox                  from 'pages/tirgul/inputQuestion/eggBox';
import { reducerType }         from 'reducer';
import { makeStyles }          from "makeStyles";
import sizes                   from 'utils/sizes';
import { componentsStateType } from 'reducer/types';

const clsx = require('classnames')

const useStyles = makeStyles()(
    (theme) => ({
        root: {
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
          width:           '100%',
        },
        container : {
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
        },
        column : {
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            flexFlow:        'column',

        },
        row : {
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'space-evenly',
            flexFlow:        'row',
            border:          '1px solid #CCC',
            borderRadius:    '0.4em',
          //  background:      '#F6F6FF'
        },
        input: {
            width:           '100%',
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            color:           theme.darkBlue,
            fontSize:        75,
            height:          100,
            marginTop:       15,
            zIndex:          1
        },
        input2: {
            color:     theme.darkBlue,
            marginTop: 0,
            zIndex:    0,
            fontSize:  23,
        },
        questionText: {
            height:          45,
            width:           250,
            fontSize:        22,
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            borderRadius:    '0.5em',
            color:           theme.darkBlue,
            border:          `1px solid ${ theme.darkBlue }`
        }
    }),
);

type QuestionPropsType = {
    size:            number[];
    question:        number;
    failurCount:     number;
    variant:         string;
    textInput:       string;
    wideScreen:      boolean;
    success:         boolean;
    componentsState: componentsStateType;
}

const Question: React.FC<QuestionPropsType> = ({
    size,
    componentsState,
    variant,
    wideScreen,
    question,
    failurCount,
    textInput,
    success,
}) => {

    const { classes } = useStyles();

   // console.log('question : ',question)

     const [num1, num2] = React.useMemo(() => {

        if (!question) {
            return [0,0]
        }
        if ( question < 10 ) {
            return [0, question];
        }
        return [Math.floor(question/10), question%10]
    },[question])



   const [rootStyle, containerStyle, rowStyle, inputStyle] = React.useMemo(() => {

     const { bigBoxHeight, smallBoxHeight, bigBoxWidth, smallBoxWidth ,bigBoxGap, smallBoxGap } = sizes;

     const boxHeight = wideScreen ? bigBoxHeight : smallBoxHeight;
     const boxWidth  = wideScreen ? bigBoxWidth : smallBoxWidth;
     const BoxGap    = wideScreen ? bigBoxGap : smallBoxGap;

     const defaulHeight = num1 < 2;


     const height = defaulHeight ? undefined : boxHeight + (num1 * BoxGap);

     return[
         {
            minHeight: variant === 'input' ? '35vh' : undefined
         }, 
         {
            height: height
         },
         {
            height: height,
            //width:  wideScreen ? ((boxWidth * 2) + 30 ) : '40vw'
            width:  wideScreen ? ((boxWidth * 2) + 100 ) : '60vw'
         },
         {
            fontSize: size[1] > 750 ? 75  : 28,
            height:   size[1] > 750 ? 100 : 40,
         }
      ]
   },[num1, variant, wideScreen, size])


    return(
        <div 
            className = { classes.root }
            style     = { rootStyle }
        >
            <div 
               className = { classes.container }             
               style     = { containerStyle }
            >
                {
                    variant === 'input' && 
                    <div className = { classes.column } >
                        <div 
                           className = { classes.row }
                           style     = { rowStyle }
                        >
                            {
                                !!num1 &&
                                <EggBox
                                   value      = { num1 }
                                   variant    = 'tens'
                                   wideScreen = { wideScreen }
                                   showButton
                                   showClosed
                                />
                            }
                            {
                                !!num2 &&
                                <EggBox
                                   value      = { num2 }
                                   wideScreen = { wideScreen }
                                   showClosed
                                />
                            }
                        </div>

                        {
                            Boolean(!success && failurCount >= 3) &&
                            <>
                                <div 
                                  className = { clsx(classes.input/* , classes.input2 */) }
                                  style     = { inputStyle }
                                >
                                  { question }
                                </div> 
                                <div className = { clsx(classes.input2) }>
                                  תשובה
                                </div> 
                            </>
                        }
                        {
                            !Boolean(!success && failurCount >= 3) &&
                            <div 
                               className = { classes.input }
                               style     = { inputStyle }
                            >
                              { textInput }
                            </div>
                        }
                    </div>
                }
                {
                    variant === 'dnd' && 
                    <div className = { classes.questionText }>
                       { question } 
                    </div>
                }
            </div>
        </div>
    )
}


  

  const mapStateToProps = (reducer: reducerType) => {

    const { textInput, failurCount, success } = reducer.components
    return {
      componentsState: reducer.components,
      textInput:       textInput,
      failurCount:     failurCount,
      success:         success
  }};
  
  export default connect(mapStateToProps)(Question);
  
  
  
  